// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { DateTimeUtils } from "../Utils/Time/DateTimeUtils.js";
import { DataCache } from "./DataCache.js";

let RecalculateCounter = 0;

export function RecalculateBalances ()
{
    //TODO тупой апдейт надо переделать
    if (RecalculateCounter === 5)
    {
        DataCache.RecalculateBalances();
        RecalculateCounter = 0;
    }

    RecalculateCounter++;
}